"use client";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./getHaveideaQoute02.css";
import { Link } from "react-router-dom";

const GethaveIdeaQoute = () => {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 100,
      duration: 1000,
    });
  }, []);

  return (
    <section className="heroSection">
      {/* LEFT SIDE: IMAGE */}
      <div className="imageContainer" data-aos="fade-right">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/ee43fa5da7dd8ae96db63908699f863465001a85"
          alt="Decorative illustration"
          className="heroImage"
        />
      </div>

      {/* RIGHT SIDE: TEXT */}
      <div className="textContent" data-aos="fade-left">
        <h1 className="qouteTitle">
          Have a Great Idea? <br />
          Let's Bring it to Life!
        </h1>

        <p className="subheading">
          <span>Let's transform your </span>
          <span className="highlight">idea</span>
          <span> into a </span>
          <span className="highlight">revolutionary</span>
          <span> digital product !-your idea deserves the best!</span>
        </p>

        <span className="callToAction">
          Send us your requirements on contact.starlinklab@gmail.com 
        </span>
        <br />

        <Link to="/contactform">
          <button className="ctaButton" data-aos="zoom-in" data-aos-delay="100">
            <span className="buttonText">Let's Connect Us!</span>
          </button>
        </Link>
      </div>
    </section>
  );
};

export default GethaveIdeaQoute;
